import { PDFium } from './pdfium-manager';
import { PDFiumModule } from './pdfium';

// variables
export let pageLoaded = false;
export let moduleLoaded = false;

(function () {
  if (!('WebAssembly' in window)) {
    console.error('You need a browser with Web Assembly support enabled :(');
    return;
  }

  pageLoaded = true;
  console.log('The page was loaded!');
})();

PDFiumModule().then(function (pdfiumModule) {
  PDFium.Module = pdfiumModule;
  moduleLoaded = true;
});
